/**
 * tourEvents — a minimal module-level pub/sub for tour lifecycle signals.
 *
 * Its whole reason to exist is the dependency direction: the ledger drawer needs
 * to know when a page tour it launched has ended (to auto-reopen with the
 * conversation intact — 03 §3.3 revised), but TourProvider must NOT import any
 * ledger code. So the tour layer only ever EMITS here; the ledger layer
 * subscribes. One-way, no cycle.
 */
const listeners = new Set();

/** Announce that a page tour ended (fired on BOTH complete and cancel).
 * @param {{tourId: string, launchedFrom: string}} detail */
export function emitPageTourEnded(detail) {
  listeners.forEach((fn) => {
    try {
      fn(detail);
    } catch {
      /* a bad subscriber must never break tour teardown */
    }
  });
}

/** Subscribe to pageTourEnded. Returns an unsubscribe fn. */
export function subscribePageTourEnded(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
